import React, { FunctionComponent, useState } from 'react';
import Loader from '@justgiving/loading/es/Loading';

import Modal from '../Modal/Modal';

import styles from './CheckoutModal.scss';
import { useTranslation } from 'react-i18next';
import Svg from '@justgiving/svg';
import { closeIcon } from '@justgiving/icons';
import IconButton from '../IconButton/IconButton';
import { useApp } from '../../hooks';

type CheckoutModalProps = {
  onClose: () => void;
};

export const CheckoutModal: FunctionComponent<CheckoutModalProps> = ({
  onClose,
}) => {
  const [isLoading, setIsLoading] = useState(true);
  const { t } = useTranslation('common', { useSuspense: false });
  const { checkoutModalHref } = useApp();
  return (
    <>
      <Modal
        onCloseRequest={onClose}
        className={styles.modal}
        modalTitle={t('checkout.modalTitle')}
        closeOnClickOutsideModal={false}
        removeScrollbar
      >
        <IconButton
          className={styles.modalCloseButton}
          onClick={onClose}
          aria-label={t('common.close')}
        >
          <Svg markup={closeIcon} />
        </IconButton>
        {isLoading && (
          <Loader size="large" colour="grey" className={styles.loader} />
        )}
        <iframe
          title={t('checkout.title')}
          src={checkoutModalHref}
          className={styles.iframe}
          allow="payment *"
          onLoad={() => setIsLoading(false)}
        ></iframe>
      </Modal>
    </>
  );
};
